import { render } from "./SwitchLanguage.vue?vue&type=template&id=11e90ee4"
import script from "./SwitchLanguage.vue?vue&type=script&lang=js"
export * from "./SwitchLanguage.vue?vue&type=script&lang=js"

import "./SwitchLanguage.vue?vue&type=style&index=0&id=11e90ee4&lang=css"

import exportComponent from "/app/websites/dizztinct/dizztinct-patient/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__